/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        03/03/2022 16:01
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import {addFilter} from "@wordpress/hooks"

export default class HookService {
    constructor() {
        addFilter("iris_core_easepick_stylesheet_url", "iris-core", () => IRISCollectionTheme.easepickStyleUrl, 10)
    }
}
